import { Component, Input } from '@angular/core';
import _ from 'lodash';

@Component({
  selector: 'app-form-input-error',
  standalone: false,
  templateUrl: './form-input-error.component.html',
  styleUrls: ['./form-input-error.component.scss']
})
export class FormInputErrorComponent {
  @Input() dateAfter: {date: string};
  @Input() duplicated: boolean | string;
  @Input() email: boolean;
  @Input() extension: {options: string};
  @Input() forbidden: boolean;
  @Input() hourAfter: {date: string};
  @Input() initialWeekDay: {date: string, day: string};
  @Input() max: {max: number, actual: number};
  @Input() maxlength: {actualLength: number, requiredLength: number};
  @Input() min: {min: number, actual: number};
  @Input() minLengthArray: {min: number} | undefined;
  @Input() passwordRepeat: boolean;
  @Input() pattern: boolean;
  @Input() required: boolean | string;
  @Input() requiredOne: {fields: string};
  @Input() show: boolean;
  @Input() weekDayIncluded: {weekDay: string};

  public _ = _;
}
